import classNames from "classnames";
import logo from "./assets/logo.svg";

export const Logo = ({ className }: { className?: string }) => {
  return <img className={classNames("size-full", className)} alt="Home" src={logo} />;
};
